import { render, staticRenderFns } from "./CallingNumbersManage.vue?vue&type=template&id=24dd09ad&scoped=true"
import script from "./CallingNumbersManage.vue?vue&type=script&lang=js"
export * from "./CallingNumbersManage.vue?vue&type=script&lang=js"
import style0 from "./CallingNumbersManage.vue?vue&type=style&index=0&id=24dd09ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd09ad",
  null
  
)

export default component.exports